var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('router-link',{attrs:{"to":'/dialogkontrolle/' + _vm.dialogId}},[_vm._v("\n    "+_vm._s(_vm.dialogId)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }